import { WiseOwlChatType, WiseOwlApiIngress, MessageRole } from "../types";

const chatById: WiseOwlChatType = {
  createdAt: "2023-11-02T22:02:53.627Z",
  id: "1c40bb13-e680-43b3-8d61-da9e17ca9e75",
  ingress: WiseOwlApiIngress.OneSupportCenter,
  blocks: [],
  messages: [
    {
      chatId: "1c40bb13-e680-43b3-8d61-da9e17ca9e75",
      content: "Hello wise owl",
      createdAt: "2023-11-02T22:02:54.517Z",
      id: "40a48d7a-357e-4d23-a661-142396a96c52",
      messageRole: MessageRole.User,
      isComplete: null,
      slackMessageTimestamp: null,
      updatedAt: "2023-11-02T22:02:54.517Z",
      userId: "nobody",
      toolCalls: [],
    },
    {
      chatId: "1c40bb13-e680-43b3-8d61-da9e17ca9e75",
      content: "Hello! How can I assist you with Twilio today?",
      createdAt: "2023-11-02T22:02:54.517Z",
      id: "40a48d7a-357e-4d23-a661-142396a96c53",
      messageRole: MessageRole.Assistant,
      isComplete: true,
      slackMessageTimestamp: null,
      updatedAt: "2023-11-02T22:02:54.517Z",
      userId: "AI",
      toolCalls: [],
    },
    {
      chatId: "1c40bb13-e680-43b3-8d61-da9e17ca9e75",
      content: "What is error code 30034?",
      createdAt: "2023-11-02T22:03:14.275Z",
      id: "40a48d7a-357e-4d23-a661-142396a96c54",
      messageRole: MessageRole.User,
      isComplete: null,
      slackMessageTimestamp: null,
      updatedAt: "2023-11-02T22:03:14.275Z",
      userId: "nobody",
      toolCalls: [],
    },
    {
      chatId: "1c40bb13-e680-43b3-8d61-da9e17ca9e75",
      content:
        "This error occurs when messages sent to US numbers are not delivered.",
      createdAt: "2023-11-02T22:03:14.275Z",
      id: "40a48d7a-357e-4d23-a661-142396a96c56",
      messageRole: MessageRole.Assistant,
      isComplete: true,
      slackMessageTimestamp: null,
      updatedAt: "2023-11-02T22:03:14.275Z",
      userId: "AI",
      toolCalls: [],
    },
  ],
  slackConversationId: null,
  slackThreadTimestamp: null,
  title: "Hello wise owl",
  updatedAt: "2023-11-02T22:02:53.627Z",
  userId: "nobody",
  aboutTicketId: 123456,
};

export default chatById;
